import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Quote, ChevronLeft, ChevronRight } from "lucide-react";

export default function TestimonialsSlider({ items = [] }) {
  const [i, setI] = useState(0);
  const len = items.length;

  useEffect(() => {
    if (len <= 1) return;
    const t = setInterval(() => setI((x) => (x + 1) % len), 7000);
    return () => clearInterval(t);
  }, [len]);

  if (!len) return null;
  const t = items[i];

  return (
    <section className="py-20 bg-[#f8f4e8] grain" data-testid="testimonials-section">
      <div className="dk-container">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-4">
            <span className="text-[#0d1724] tracking-[0.3em] text-xs font-semibold uppercase">Voices from the field</span><p className="text-[11px] text-[#0a0d12]/55 mt-1" data-testid="testimonials-privacy-note">Photos shown with consent; where a photo is absent, names or details may have been adjusted for privacy and safeguarding. <Link to="/impact#stories" className="underline">Read longer stories →</Link></p>
            <h2 className="font-serif text-[#0a0d12] text-3xl md:text-5xl font-bold mt-3">
              Stories of <span className="italic text-[#d6aa43]">hope</span> and change.
            </h2>
          </div>
          <div className="lg:col-span-8">
            <div className="relative bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-black/5">
              <Quote className="absolute -top-4 left-8 text-[#d6aa43]" size={36} fill="#d6aa43" />
              <p
                key={i}
                className="font-serif text-2xl md:text-3xl text-[#0a0d12] leading-snug fade-up"
                data-testid="testimonial-quote"
              >
                "{t.quote}"
              </p>
              <div className="mt-8 flex items-center justify-between gap-4">
                <div className="flex items-center gap-4">
                  {t.image_url ? (
                    <img src={t.image_url} alt={t.author_name} className="w-12 h-12 rounded-full object-cover ring-2 ring-[#d6aa43]/30" />
                  ) : (
                    <div className="w-12 h-12 rounded-full bg-[#155e3f] text-[#d6aa43] font-serif font-bold flex items-center justify-center">
                      {t.author_name?.[0] || "D"}
                    </div>
                  )}
                  <div>
                    <div className="font-semibold text-[#0a0d12]">{t.author_name}</div>
                    <div className="text-xs uppercase tracking-[0.18em] text-[#0d1724]/60">{t.author_role}</div>
                  </div>
                </div>
                {len > 1 && (
                  <div className="flex gap-2">
                    <button
                      onClick={() => setI((x) => (x - 1 + len) % len)}
                      className="w-10 h-10 rounded-full border border-[#0d1724]/15 hover:bg-[#0f4a32] hover:text-[#d6aa43] text-[#0d1724] flex items-center justify-center transition"
                      aria-label="Previous"
                      data-testid="testimonial-prev"
                    >
                      <ChevronLeft size={18} />
                    </button>
                    <button
                      onClick={() => setI((x) => (x + 1) % len)}
                      className="w-10 h-10 rounded-full border border-[#0d1724]/15 hover:bg-[#0f4a32] hover:text-[#d6aa43] text-[#0d1724] flex items-center justify-center transition"
                      aria-label="Next"
                      data-testid="testimonial-next"
                    >
                      <ChevronRight size={18} />
                    </button>
                  </div>
                )}
              </div>
            </div>
            {len > 1 && (
              <div className="mt-5 flex gap-1.5">
                {items.map((t, idx) => (
                  <button
                    key={t.id || t.name || idx}
                    onClick={() => setI(idx)}
                    className={`h-1 rounded-full transition-all ${idx === i ? "w-8 bg-[#d6aa43]" : "w-4 bg-[#155e3f]/20 hover:bg-[#0f4a32]/40"}`}
                    aria-label={`Testimonial ${idx + 1}`}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
